import { NotificationManager as Notification } from 'react-notifications';

// TODO: implement: if callback + missing time => sticky
//const STICKY_TIME = 10000;

export default Notification;